module.exports = __webpack_public_path__ + "static/media/ic_touxiang_duoren.f75a2d72.png";